export default __webpack_public_path__ + "static/media/ansible.29daedfd.svg";